import React from 'react';
import Providers from '../constants/SocialPayConstants';
const { TWITTER } = Providers;
import { FormFieldWithLabel as FormField } from 'views/FormComponents';
import root from 'window-or-global';

export default function decorateSocialPay (Component) {
  return class SocialPayComponent extends Component {
    constructor (props) {
      super(props);
    }

    renderSocialPayButtons (props) {
      const { offer: { socialpayPlatforms } } = props;
      return socialpayPlatforms.map((platform, index) => {
        switch (platform) {
          case TWITTER:
            return (
              <FormField key={`social_${index}`}>
                <button onClick={() => this.props.handleSetSocialPayPlatformAndSubmitForm(TWITTER)}
                  className="btn btn-block btn-twitter"
                  type="button"
                  >
                  <i className="icon icon-twitter push-half--right"/>
                  Pay with a Tweet
                </button>
              </FormField>
            );
          default:
            return null;
        }
      });
    }

    submitSocialPay (selectedSocialPayPlatform, serverForm) {
      let windowName = 'socialpay:' + (selectedSocialPayPlatform || 'unknown');

      // Open a new dialog.
      let w = 400;
      let h = 400;
      let wLeft = root.screenLeft ? root.screenLeft : root.screenX;
      let wTop = root.screenTop ? root.screenTop : root.screenY;
      let left = wLeft + Math.max((root.innerWidth / 2) - (w / 2), 0);
      let top = wTop + Math.max((root.innerHeight / 2) - (h / 2), 0);
      /*globals windows*/
      windows[selectedSocialPayPlatform] = root.open('', windowName, 'width=' + w + ',height=' + h + ',top=' + top + ',left=' + left + ',status=1,location=1,resizable=yes,scrollbars=yes');
      serverForm.target = windowName;
      serverForm.submit();
    }

    render () {
      return (
        <Component
            {...this.props}
            renderSocialPayButtons={(props) => this.renderSocialPayButtons(props)}
            submitSocialPay={(selectedSocialPayPlatform, serverForm) => this.submitSocialPay(selectedSocialPayPlatform, serverForm)}
          />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/payments/decorators/SocialPay.js